module.exports = __webpack_public_path__ + "img/router.b1d53ba9.svg";